import {Media} from "react-bootstrap";
import {BASE_URL} from "../../helper/constants";
import {Skeleton} from "@material-ui/lab";
import {DE} from "../../Languages/DE";
import {EN} from "../../Languages/EN";
import React, { useState, useEffect } from "react";
import LanguageContext from "../../helper/LanguageContext";
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import {Link, useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import { convertBranchRole, convertHtmlString } from "../../helper/convertor";
import { BsChevronDown } from "react-icons/bs";
import ReadMores from "../../components/ReadMores";
import LikesDropdown from "../../components/LikesDropdown";
import { stripMarkdownFromTitle } from "../../helper/stripMarkdownTitle";
import "./ForienArticle.css";


export function ForienArticle({article, index, expandArticle, reloadArticle, company, removeArticle, viewArticleDetail, handleLike, hideLikeFollow}) {
    const {isGerm, strings} = React.useContext(LanguageContext);
    const user = useSelector(state => state.user)
    const history = useHistory();
    const [articleBranch,setArticleBranch]=React.useState([])
    const [isExpanded, setIsExpanded] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [overlayVisible, setOverlayVisible] = useState(true);
    const [likeAnimating, setLikeAnimating] = useState(false);

    // Determine if it's a Kjuup+ company
    const isKjuup = company?.isKjuup || false;
    const themeColor = isKjuup ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)';
    // own article: no colour class; liked: theme colour; otherwise grey
    const likeColorClass = user?.id === article.postedById ? '' : (article.likeStatus ? `forien-article-card__like--liked${isKjuup ? ' forien-article-card__like--internal' : ''}` : 'forien-article-card__like--idle');

    const getCompany = (createdById) => {
        if (createdById === user?.id) {
            history.push({
                pathname: "/cockpit",
                search: `?tab=company&company=${encodeURIComponent(createdById)}`,
            })
        } else {
            history.push({
                pathname: `/foreign-company-details/${createdById}`,
            })
        }
    }

    useEffect(()=>{
        let tempRole=article?.buildingIndustryRole?.split(",")
        let temoVal=tempRole?.map((itm,index)=>(index? ", ":"")+convertBranchRole(itm,isGerm))
        setArticleBranch(temoVal)
    },[article])

    // Check if article has images
    const hasImages = article.uploadUrl && article.uploadUrl.length > 0;

    return (
        <div className={`no-company forien-article-card${hasImages && !isExpanded ? ' forien-article-card--media-collapsed' : ''}`}>
            <Media>
                {
                    (article.logo || article.avatar || article.postedByImage || company?.logo) &&
                    <img
                        width={40}
                        height={40}
                        className="mr-3 news_profile forien-article-card__logo"
                        src={article.logo ? BASE_URL + article.logo : article.avatar ? BASE_URL + article.avatar : article.postedByImage ? BASE_URL + article.postedByImage : company?.logo ? BASE_URL + company.logo : process.env.PUBLIC_URL + "assets/img/company.png"}
                        alt="Generic placeholder"
                    />
                }
                {
                    !article.logo && !article.avatar && !article.postedByImage && !company?.logo &&
                    <img
                        width={40}
                        height={40}
                        className="mr-3 news_profile forien-article-card__logo"
                        src={process.env.PUBLIC_URL + "/assets/img/Companies-No-Image.svg"}
                        alt="Generic placeholder"
                    />
                }
                <Media.Body>
                    <div className="authore_name">
                        <div className="authore_name">
                            {
                                article.id ?
                                    <h5 onClick={e => getCompany(article.createdById)}>{article.userFullName || article.createdBy}</h5> :
                                    <Skeleton variant="text"/>
                            }
                        </div>
                        {
                            article.postedByName ?
                                <h6 className="text-itallic">{article.postedByName ? article.postedByName :
                                    <Skeleton variant="text"/>} -
                                    <span>
                                         {article.id ? articleBranch :
                                        <Skeleton variant="text"/>}
                                    </span></h6> :
                                <Skeleton variant="text"/>
                        }
                        <div className="w-100">
                            {
                                article.product ?
                                    <h6 className="product_user">Product: <span>{article.product}</span></h6> : ''
                            }
                        </div>
                    </div>
                    <div className="side_icon forien-article-card__actions">
                    </div>
                </Media.Body>
            </Media>
            {
                article.id ?
                    <p className="m-0 mt-2 mb-2"><Link to={`/feed-detail/${article.id}`}
                                                  className="font-weight-bold forien-article-card__title">{stripMarkdownFromTitle(article.title || '')}</Link></p> :
                    <Skeleton variant="text"/>
            }
            {article.description && (
                <div className="small forien-article-card__desc">
                    <ReadMores isInternal={isKjuup}>
                        {article.description}
                    </ReadMores>
                </div>
            )}

            {hasImages && (
                <>
                    {!isExpanded ? (
                        // Preview mode - show half of gallery behind blurred overlay
                        <div
                            className="forien-article-card__preview"
                            onClick={() => {
                                setIsTransitioning(true);
                                setIsExpanded(true);
                                setTimeout(() => {
                                    setOverlayVisible(false);
                                    setIsTransitioning(false);
                                }, 400);
                            }}
                        >
                            {/* Full image gallery in background - showing only top half */}
                            <div className="forien-article-card__preview-gallery">
                                <div className="forien-article-card__preview-gallery-inner">
                                    <Carousel
                                        additionalTransfrom={0}
                                        arrows={article.uploadUrl.length > 1}
                                        centerMode={false}
                                        className="p-0"
                                        dotListClass=""
                                        draggable={article.uploadUrl.length > 1}
                                        focusOnSelect={false}
                                        infinite={false}
                                        itemClass=""
                                        keyBoardControl
                                        minimumTouchDrag={80}
                                        renderButtonGroupOutside={false}
                                        renderDotsOutside={false}
                                        responsive={{
                                            desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
                                            mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
                                            tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 }
                                        }}
                                        showDots={article.uploadUrl.length > 1}
                                        sliderClass=""
                                        slidesToSlide={1}
                                        swipeable
                                    >
                                        {article.uploadUrl.map((image, idx) => (
                                            <div key={idx} className="profile_slider embed-responsive embed-responsive-16by9">
                                                <img
                                                    className="pointer embed-responsive-item forien-article-card__slide-img"
                                                    src={BASE_URL + image.fileUrl}
                                                    alt=""
                                                />
                                            </div>
                                        ))}
                                    </Carousel>
                                </div>
                            </div>
                            
                            {/* Blurred overlay */}
                            {overlayVisible && (
                                <div
                                    className={`forien-article-card__overlay${isTransitioning ? ' forien-article-card__overlay--hidden' : ''}`}
                                >
                                    <div className="forien-article-card__overlay-content">
                                        <div className="forien-article-card__overlay-arrow">
                                            <BsChevronDown 
                                                size={20} 
                                                color="#737373"
                                                className="forien-article-card__nudge"
                                            />
                                        </div>
                                        {article.uploadUrl.length > 1 && (
                                            <span className="forien-article-card__count">
                                                {article.uploadUrl.length} {isGerm ? 'Bilder' : 'Images'}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        // Expanded mode - show all images
                        <div className="forien-article-card__expanded">
                            <Carousel
                                additionalTransfrom={0}
                                arrows={article.uploadUrl.length > 1}
                                centerMode={false}
                                className="p-0"
                                dotListClass=""
                                draggable={article.uploadUrl.length > 1}
                                focusOnSelect={false}
                                infinite={false}
                                itemClass=""
                                keyBoardControl
                                minimumTouchDrag={80}
                                renderButtonGroupOutside={false}
                                renderDotsOutside={false}
                                responsive={{
                                    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
                                    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
                                    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 }
                                }}
                                showDots={article.uploadUrl.length > 1}
                                sliderClass=""
                                slidesToSlide={1}
                                swipeable
                            >
                                {article.uploadUrl.map((image, idx) => (
                                    <div key={idx} className="profile_slider embed-responsive embed-responsive-16by9">
                                        <img
                                            className="pointer embed-responsive-item forien-article-card__slide-img"
                                            onClick={() => viewArticleDetail && viewArticleDetail(article)}
                                            src={BASE_URL + image.fileUrl}
                                            alt=""
                                        />
                                    </div>
                                ))}
                            </Carousel>
                            {/* Collapse button */}
                            <div
                                className="forien-article-card__collapse"
                                onClick={() => {
                                    setIsExpanded(false);
                                    setOverlayVisible(true);
                                    setIsTransitioning(false);
                                }}
                            >
                                <div
                                    className="forien-article-card__collapse-pill"
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.1)'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)'; }}
                                >
                                    <BsChevronDown 
                                        size={16} 
                                        color="#737373"
                                        className="forien-article-card__chevron-up"
                                    />
                                    <span className="forien-article-card__count">
                                        {isGerm ? 'Weniger anzeigen' : 'Show less'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            <div className="date-follow">
                <p>{new Date(article.createdAt).toLocaleDateString(isGerm ? 'de-DE' : 'en-GB', {
                    day: 'numeric',
                    month: 'long'
                })}, {new Date(article.createdAt).toLocaleTimeString(isGerm ? 'de-DE' : 'en-US', {
                    hour: '2-digit',
                    minute: '2-digit'
                })}</p>
                {!hideLikeFollow && (
                <LikesDropdown 
                    articleId={article.id} 
                    likes={article.likes} 
                    likeCount={article.likeCount}
                    isInternal={isKjuup}
                >
                    <div className="follow-img">
                        <div className="likes-avatar-container">
                            {
                                article.likes && Array.isArray(article.likes) &&
                                article.likes.map((like, i) => (
                                    i >= 3 ?
                                    <React.Fragment key={`fragment-${i}`}></React.Fragment>
                                    :
                                    like?.avatar ?
                                        <img 
                                            key={like?.id || `like-${i}`}
                                            className="like-avatar-enter forien-article-card__like-avatar"
                                            src={BASE_URL + like.avatar}
                                            alt={like?.userFullName || like?.fullName || "Generic placeholder"} /> :
                                        <div key={like?.id || `like-svg-${i}`} className="svg_icon news_profile like-avatar-enter forien-article-card__like-icon">
                                            <svg width="14px" height="14px" id="Layer_4" data-name="Layer 4"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.54 39.54">
                                                <path className="cls-1"
                                                    d="M271.14,229.57l-3.12,1.5a19.26,19.26,0,0,0,13.16,5.26h.17a19.28,19.28,0,0,0,12.32-4.53c-1.32-.59-4.69-2.23-4.69-2.23s-.17-2.74-1.19-2.9l.17-1.85a13.45,13.45,0,0,0,1.19-4.18s1.19,1,1.62-1.21,1-6.19-.85-5.23a22.92,22.92,0,0,0,0-5.14c-.34-1.93-2.08-7.88-9.9-7.88s-9.57,5.95-9.91,7.88a22.69,22.69,0,0,0,.05,5.14c-1.87-1-1.28,3.06-.85,5.23s1.61,1.21,1.61,1.21a13.45,13.45,0,0,0,1.19,4.18l.17,1.85C271.30,226.83,271.14,229.57,271.14,229.57Z"
                                                    transform="translate(-261.48 -197.24)" />
                                                <circle className="cls-2" cx="19.77" cy="19.77" r="19.32" />
                                            </svg>
                                        </div>
                                ))
                            }
                        </div>

                        <span className="like-count-transition">
                            {(() => {
                                if (!article.likes || !Array.isArray(article.likes) || article.likes.length === 0) {
                                    return article.likeCount ? article.likeCount : '';
                                }
                                
                                const firstLike = article.likes[0];
                                const userName = firstLike?.userFullName || firstLike?.fullName || 
                                    (firstLike?.firstName && firstLike?.lastName ? 
                                        `${firstLike.firstName.trim()} ${firstLike.lastName.trim()}` : 
                                        null);
                                
                                if (userName && article.likeCount > 0) {
                                    if (article.likeCount === 1) {
                                        return userName;
                                    } else {
                                        return `${userName} ${isGerm ? "und" : "and"} ${article.likeCount - 1} ${isGerm ? "andere" : "others"}`;
                                    }
                                }
                                
                                return article.likeCount ? article.likeCount : '';
                            })()}
                        </span>
                    </div>
                </LikesDropdown>
                )}
            </div>
            {!hideLikeFollow && (
            <div className="date-follow no-border like_folo no-hover-effect">
                <a
                    onClick={(e) => {
                        if (user?.id !== article.postedById && handleLike) {
                            setLikeAnimating(true);
                            handleLike(article.id);
                            setTimeout(() => setLikeAnimating(false), 300);
                        }
                    }}
                    className={`date-follow-link ${user?.id === article.postedById ? 'date-follow-link-deactivated' : 'pointer'} ${article.likeStatus ? (isKjuup ? 'social-icon-active_internal' : 'social-icon-active') : ''}`}
                >
                    <span
                        className={`material-symbols-outlined mr-1 forien-article-card__like-icon${article.likeStatus ? ' forien-article-card__like-icon--filled' : ''}${likeAnimating ? ' forien-article-card__like-icon--pop' : ''} ${likeColorClass}`}
                    >
                        thumb_up
                    </span>
                    <span
                        className={`date-follow-label forien-article-card__like-label ${likeColorClass}`}
                    >
                        {strings.like}
                    </span>
                </a>
            </div>
            )}
        </div>
    );
}
